<div
  class="backdrop"
  [ngClass]="{ 'full-screen': config?.fullScreenBackdrop === true }"
  [ngStyle]="{
    'border-radius': config?.backdropBorderRadius,
    'background-color': config?.backdropBackgroundColour
  }"
></div>
<div [ngSwitch]="config?.animationType">
  <div
    class="spinner-chasing-dots"
    *ngSwitchCase="appLoaderAnimationTypes.chasingDots"
    [ngClass]="{ 'full-screen': config?.fullScreenBackdrop === true }"
  >
    <div class="dot1" [ngStyle]="{ 'background-color': config?.primaryColour }"></div>
    <div class="dot2" [ngStyle]="{ 'background-color': config?.secondaryColour }"></div>
  </div>

  <div *ngSwitchCase="appLoaderAnimationTypes.none" [ngClass]="{ 'full-screen': config?.fullScreenBackdrop === true }"></div>
  <div *ngSwitchDefault class="spinner-three-bounce" [ngClass]="{ 'full-screen': config?.fullScreenBackdrop === true }">
    <div class="bounce1" [ngStyle]="{ 'background-color': config?.primaryColour }"></div>
    <div class="bounce2" [ngStyle]="{ 'background-color': config?.secondaryColour }"></div>
    <div class="bounce3" [ngStyle]="{ 'background-color': config?.tertiaryColour }"></div>
  </div>
  <ng-container *ngIf="template">
    <ng-container *ngTemplateOutlet="template"></ng-container>
  </ng-container>
</div>
